import { ImageInput } from '@/lib/formFactory/image';

export default class ImageEntity {
    defaultValue: ImageInput;
    entityName: string;
    entity: any;
    
    constructor(name: string) {
        this.defaultValue = {
            key: name,
            title: '',
            value: '',
            required: false,
            error: {
                class: '',
                message: '',
            },
        };
        this.entityName = name;
        this.entity = { [this.entityName]: this.defaultValue };
    }
    
    setTitle(title: string) {
        this.entity[this.entityName]['title'] = title;
    }
    
    setRequired(required: boolean) {
        this.entity[this.entityName]['required'] = required;
    }
    
    setKey(key: string) {
        this.entity[this.entityName]['key'] = key;
    }
}
